module.exports = __webpack_public_path__ + "img/isno.70cce37a.png";